export const SEARCH_NEIGHBORHOOD = 'SEARCH_NEIGHBORHOOD'
export const ARRAY_LIST_TO_DROPDOWN_ALGOLIA_NEIGHBORHOOD = 'ARRAY_LIST_TO_DROPDOWN_ALGOLIA_NEIGHBORHOOD'
export const IS_LOADING_ALGOLIA_NEIGHBORHOOD = 'IS_LOADING_ALGOLIA_NEIGHBORHOOD'
